import React, { ReactNode } from 'react';
import { ContentWrapperDnDContext } from '../../../blocks/ContentWrapper/ContentWrapperDndProvider';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export enum BlockInteractionsBarModifier {
  SLIM = 'slim',
}

type BlockInteractionsBarType = {
  contentWrapperDndContext?: ContentWrapperDnDContext | null;
  children: ReactNode;
  modifier?: Modifier<BlockInteractionsBarModifier>;
};

export function BlockInteractionsBar({ contentWrapperDndContext, children, modifier }: BlockInteractionsBarType) {
  return (
    <div className={bem('block-interactions__bar', modifier)} {...contentWrapperDndContext}>
      {children}
    </div>
  );
}
